export const cim = [
  {
    path: '/cim',
    name: 'cim',
    component: () => import('@/views/login/cim/Index.vue'),
  },
  {
    path: '/cim/email/:step',
    name: 'login',
    component: () => import('@/views/login/cim/Index.vue'),
  },
  {
    path: '/cim/register/:type/:step', // account detail
    name: 'CIM-register',
    component: () => import('@/views/login/cim/register/index.vue'),
  },
  {
    path: '/cim/register/:type/:step', // account detail
    name: 'CIM-register',
    component: () => import('@/views/login/cim/register/index.vue'),
  },
  {
    path: '/cim/reset_password/:type/:step', // account detail
    name: 'CIM-resetPassword',
    component: () => import('@/views/login/cim/reset-password/index.vue'),
  },
]
